export interface PostGradState {
  postGradCourses: any[];
}

const state: PostGradState = {
  postGradCourses: [],
};

export default state;
